import React from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  width: 100%;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  margin-top: 2rem;
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 0 1rem;
  
  @media (max-width: 480px) {
    flex-direction: column;
    text-align: center;
  }
`;

const Links = styled.div`
  display: flex;
  gap: 1.5rem;
  
  @media (max-width: 480px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const StyledLink = styled(Link)`
  color: var(--primary);
  text-decoration: none;
  font-size: 0.9rem;
  
  &:hover {
    text-decoration: underline;
  }
`;

const Copyright = styled.p`
  color: #666;
  font-size: 0.9rem;
`;

const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <Content>
        <Copyright>© {year} Pop Fidget Toy. All rights reserved.</Copyright>
        <Links>
          <StyledLink to="/privacy">Privacy Policy</StyledLink>
          <StyledLink to="/terms">Terms of Service</StyledLink>
        </Links>
      </Content>
    </FooterContainer>
  );
};

export default Footer; 